

export namespace blob {

  /**
     * 通过Blob读取JSON对象
     * @param {*} event
     */
  export function readJsonObject<T>(blob: Blob, callback?: (data: T) => void) {
    let reader = new FileReader();
    reader.readAsBinaryString(blob);

    reader.onload = function () {
      //是否需要retry
      let result = reader.result as string;
      let resultToJson = JSON.parse(result);
      callback && callback(resultToJson);
    }
  }

  /**
   * 将Base64字符串，转成bolb对象
   * @param base64String
   * @returns
   */
  export function fromBase64String(base64String: string): Blob {

    const parts = base64String.split(';base64,');

    if (!parts || parts.length != 2) {
      throw new Error("This is not a base64 string.");
    }

    const contents = parts[0].split(':');

    if (!contents || contents.length != 2) {
      throw new Error("This is a wrong format of base64 string.");
    }

    const contentType = contents[1];

    const sliceSize = 1024;
    const byteCharacters = atob(parts[1]);
    const bytesLength = byteCharacters.length;
    const slicesCount = Math.ceil(bytesLength / sliceSize);
    const byteArrays = new Array(slicesCount);

    for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
      const begin = sliceIndex * sliceSize;
      const end = Math.min(begin + sliceSize, bytesLength);

      const bytes = new Array(end - begin);
      for (let offset = begin, i = 0; offset < end; ++i, ++offset) {
        bytes[i] = byteCharacters[offset].charCodeAt(0);
      }
      byteArrays[sliceIndex] = new Uint8Array(bytes);
    }
    return new Blob(byteArrays, { type: contentType });
  }


  /**
  * Shim for
  * [`URL.createObjectURL()`](https://developer.mozilla.org/en-US/docs/Web/API/URL.createObjectURL)
  * to support browsers that only have the prefixed
  * `webkitURL` (e.g. Android <4.4).
  *
  * Example:
  *
  * ```js
  * var myUrl = blobUtil.createObjectURL(blob);
  * ```
  *
  * @param blob
  * @returns url
  */
  export function createObjectURL(blob: Blob): string {
    return (typeof URL !== 'undefined' ? URL : webkitURL).createObjectURL(blob)
  }

  /**
   * Shim for
   * [`URL.revokeObjectURL()`](https://developer.mozilla.org/en-US/docs/Web/API/URL.revokeObjectURL)
   * to support browsers that only have the prefixed
   * `webkitURL` (e.g. Android <4.4).
   *
   * Example:
   *
   * ```js
   * blobUtil.revokeObjectURL(myUrl);
   * ```
   *
   * @param url
   */
  export function revokeObjectURL(url: string): void {
    return (typeof URL !== 'undefined' ? URL : webkitURL).revokeObjectURL(url)
  }

}
